import React from "react";

export const RUMO_PISTA_HELP_TITLE = "Rumo de Pista A-B";

export function RumoPistaHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Definir a{" "}
        <strong>direção oficial do trabalho</strong> no talhão — pontos A e B —
        antes da operação ir para o campo. A equipe usa essa referência para
        configurar o piloto automático e executar no sentido correto, evitando
        linhas invertidas ou rumo oposto ao planejado.
      </p>
      <p>
        <strong>Como usar (passo a passo):</strong>
      </p>
      <ol>
        <li>
          Abra o mapa satélite e aumente o zoom ao máximo para precisão.
        </li>
        <li>
          Clique para marcar o <strong>Ponto A</strong> (início da referência).
        </li>
        <li>
          Clique para marcar o <strong>Ponto B</strong> (sentido do trabalho A
          → B).
        </li>
        <li>
          Arraste A ou B se precisar ajustar a posição.
        </li>
        <li>
          Anote ou copie <strong>latitude, longitude</strong>,{" "}
          <strong>rumo (°)</strong> e distância — ou salve uma captura de tela
          para repassar ao operador.
        </li>
      </ol>
      <p>
        <strong>Quando usar:</strong> plantio, pulverização ou preparo em que a
        direção das passadas importa. Ideal para repassar ao operador antes de
        ele configurar a máquina.
      </p>
      <p>
        <strong>Importante:</strong> cada fabricante de piloto pode exigir
        formato diferente. Esta ferramenta gera ponto A, ponto B e{" "}
        <strong>rumo (°)</strong> em graus — formato adequado ao sistema{" "}
        <strong>JACTO</strong>. Confira o manual da máquina antes de digitar no
        display.
      </p>
    </>
  );
}
